<div class="wrap">
  <header>
    <h3 class="heading">{{ 'pages.profile.resizeModalHeading' | translate }}</h3>
    <button class="close-button" (click)="closeModal()"><span class="icon-close"></span></button>
  </header>
  <image-cropper
    class="image-cropper"
    [class.loaded]="loaded"
    [imageFile]="imageFile"
    [format]="imageType"
    [maintainAspectRatio]="options.maintainAspectRatio"
    [aspectRatio]="1 / 1"
    (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded()"
    (cropperReady)="cropperReady()"
    (loadImageFailed)="loadImageFailed()"
  ></image-cropper>
  <div *ngIf="!loaded" class="spinner-wrapper">
    <mat-progress-spinner
      class="spinner"
      mode="indeterminate" 
      diameter="50"
    ></mat-progress-spinner>
  </div>
  <footer>
    <button class="bciti-button bciti-button--lightblue-inversed" (click)="retake()">
      {{ 'pages.profile.retakeButton' | translate }}
    </button>
    <span class="spacing"></span>
    <button
      class="bciti-button bciti-button--blue"
      (click)="complete()">
      {{ 'pages.profile.resizeModalButton' | translate }}
    </button>
  </footer>
</div>
